import { api } from "./NetworkBase";
export async function GetAccount(query) {
	return api.get("ScannerApp/client?account=" + query).json();
}

export async function GetUserName(query) {
	return api.get("ScannerApp/user-name?account=" + query).json();
}
